import { useEffect, useRef } from "react";
import { ethers } from "ethers";

import React, { useState } from "react";
import abi from '../utils/build/abi'
import { tokenAbi } from "../utils/build/tokenAbi";
import Web3 from 'web3'
import icon from '../images/history.svg';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import { Tier } from "../utils/tier";


const provider = new Web3.providers.HttpProvider(
  // "https://eth-goerli.g.alchemy.com/v2/z2_SRVFS1FIpxVI5ACfZ4s_yVibkbVxY"
  "https://data-seed-prebsc-1-s1.bnbchain.org:8545/"
  )

  const web3 = new Web3(provider)
  const tokenAddress = "0x78dbBd79beb64E2aF21b2694aC4E5E8f561757b1";
  const contractAddress = "0x22054DE3CB419D74eB47D0142BFD33A96befBc53";

  const Contract = new web3.eth.Contract(abi, "0x22054DE3CB419D74eB47D0142BFD33A96befBc53")
  const tokenContract = new web3.eth.Contract(tokenAbi, "0x78dbBd79beb64E2aF21b2694aC4E5E8f561757b1")
 
const Home = () => {

  const [stakedAmount, setStakedAmount] = useState(0);
  const [expectedReward, setExpectedReward] = useState(0);
  const [stakeAmount, setStakeAmount] = useState(0);
  const [selectedTier, setSelectedTier] = useState("Gold");
  const [rewardPercent, setRewardPercent] = useState("8");
  const [tierName, setTierName] = useState('Gold');


  const GOLD_REWARD_PERCENT = 8;
const SILVER_REWARD_PERCENT = 5;
const BRONZE_REWARD_PERCENT = 3;


  const handleTierChange = (tier) => {
    
      setSelectedTier(tier);
     
  };


  const handleStakeAmountChange = (event) => {
    setStakeAmount(event.target.value);
  }

  

  useEffect(() => {
    getStakedAmount()
    getExpectedReward()
    
    
}) 

const selectedButtonStyle = {
  backgroundColor: 'black', // Apply your desired styles
  color: 'white',
};

const unselectedButtonStyle = {
  backgroundColor: 'black',
  color: 'white',
};

const getStakedAmount = async () => {
  console.log('getStakedAmount function executed');
  console.log(selectedTier)
  // console.log(rewardPercent)
  
    const stakedAmount = await Contract.methods.getStakedAmount(window.ethereum.selectedAddress).call();
    

  console.log(stakedAmount)
  setStakedAmount(stakedAmount);
}
const getExpectedReward = async () => {
 
  const expectedReward = await Contract.methods.calculateReward(window.ethereum.selectedAddress).call();
  setExpectedReward(expectedReward);

   let rewardPercentage;
  if (selectedTier === "0") {
    rewardPercentage = GOLD_REWARD_PERCENT;
    
  } else if (selectedTier === '1') {
    rewardPercentage = SILVER_REWARD_PERCENT;
  } else if (selectedTier === '2') {
    rewardPercentage = BRONZE_REWARD_PERCENT;
  } else {
    // Handle an invalid tier if needed
    return;
  }
  setRewardPercent(rewardPercentage)
  
  console.log('Reward for', selectedTier, ':', rewardPercentage);

}



  const approveTokens = async () => {
    const nonce = await web3.eth.getTransactionCount(
      window.ethereum.selectedAddress,
      'latest'
    )
  
    const tx = {
      to: tokenAddress,
      from: window.ethereum.selectedAddress,
      value: 0, // hex
      data: tokenContract.methods
        .approve(contractAddress, "10000000000000000000000")
        .encodeABI(),
      nonce: nonce.toString(16)
    } 
      
      try {
        const txHash = await window.ethereum.request({
          method: 'eth_sendTransaction',
          params: [tx]
        })
    
        return {
          success: true,
          status: (
            <a href={`https://goerli.etherscan.io/tx/${txHash}`} target="_blank">
              <p>✅ Check out your transaction on Etherscan:</p>
              <p>{`https://goerli.etherscan.io/tx/${txHash}`}</p>
            </a>
          )
        }
      } catch (error) {
        return {
          success: false,
          status: '😞 Smth went wrong:' + error.message
        }
      }
  
  }

  const getAllowance = async (address) => {
    return await tokenContract.methods.allowance(address, contractAddress).call()
  }
  
 
    
  const stakeTokens = async () => {
    if (window.ethereum) {
      try {
        await window.ethereum.enable(); // Request account access
      } catch (error) {
        console.error("Account access denied:", error);
      }
    }
    const allowance = await getAllowance(window.ethereum.selectedAddress);
    console.log({ allowance })
    console.log(window.ethereum.selectedAddress)
    if (allowance === '0') {
    await approveTokens()
  }
const nonce = await web3.eth.getTransactionCount(
    window.ethereum.selectedAddress,
    'latest'
  )
  let tierEnum = selectedTier;
  if(selectedTier === "Gold") {
    tierEnum = '0';
  }
  else if(selectedTier === "Silver") {
    tierEnum = '1';
  }
  else if(selectedTier === "Bronze") {
    tierEnum = '2';
  }

const amount = web3.utils.toWei(stakeAmount, "wei")
console.log(tierEnum, amount)
  const tx = {
    to: contractAddress,
    from: window.ethereum.selectedAddress,
    value: 0, // hex
    data: Contract.methods
      .stake(tierEnum, amount)
      .encodeABI(),
    nonce: nonce.toString(16)
  } 
    try {
      const txHash = await window.ethereum.request({
        method: 'eth_sendTransaction',
        params: [tx]
      })
      return {
        success: true,
        status: (
          <a href={`https://goerli.etherscan.io/tx/${txHash}`} target="_blank">
            <p>✅ Check out your transaction on Etherscan:</p>
            <p>{`https://goerli.etherscan.io/tx/${txHash}`}</p>
          </a>
        )
      }
    } catch (error) {
      return {
        success: false,
        status: '😞 Smth went wrong:' + error.message
      }
    }    
  };

  const Harvest = async () => {
    if (window.ethereum) {
      try {
        await window.ethereum.enable(); // Request account access
      } catch (error) {
        console.error("Account access denied:", error);
      }
    }
const nonce = await web3.eth.getTransactionCount(
    window.ethereum.selectedAddress,
    'latest'
  )
  const tx = {
    to: contractAddress,
    from: window.ethereum.selectedAddress,
    value: 0, // hex
    data: Contract.methods
      .claimAndUnstake()
      .encodeABI(),
    nonce: nonce.toString(16)
  } 
    try {
      const txHash = await window.ethereum.request({
        method: 'eth_sendTransaction',
        params: [tx]
      })
      return {
        success: true,
        status: (
          <a href={`https://goerli.etherscan.io/tx/${txHash}`} target="_blank">
            <p>✅ Check out your transaction on Etherscan:</p>
            <p>{`https://goerli.etherscan.io/tx/${txHash}`}</p>
          </a>
        )
      }
    } catch (error) {
      return {
        success: false,
        status: '😞 Smth went wrong:' + error.message
      }
    }    
  };
  
   
  
    return (<>
        <ConnectButton.Custom>
          
      {({
        account,
        chain,
        openAccountModal,
        openChainModal,
        openConnectModal,
        authenticationStatus,
        mounted,
      }) => {
        
        const ready = mounted && authenticationStatus !== 'loading';
        const connected =
          ready &&
          account &&
          chain &&
          (!authenticationStatus ||
            authenticationStatus === 'authenticated');

        return (
          <div
            {...(!ready && {
              'aria-hidden': true,
              'style': {
                opacity: 0,
                pointerEvents: 'none',
                userSelect: 'none',
              },
            })}
          >
            {(() => {
              if (!connected) {
                return (
                  
                  <div className="p-12 w-full h-screen sm:w-[80px]">
                  <div>
                  <button onClick={openConnectModal} className="bg-gray-600 border rounded-2xl text-white px-5 py-3 sm:text-[5px] sm:px-1 sm:w-10 sm:py-1">Connect</button>
                  </div>
                  <div className="flex items-center justify-center flex-col sm:w-[310px]  ">
 
 <p className="text-white text-[13px] text-yellow-600 font-night ">METAHUMAN</p>
 <p className="text-[32px] text-white font-geological">STAKE</p>
</div>
<div className="flex items-center justify-center flex-col sm:w-[280px]  " >
 <div className="border border-gray-600 w-[800px] h-[450px] px-[2rem] mx-[5rem] sm:w-[360px] sm:h-[400px] sm:px-[0rem] sm:mr-0 sm:ml-8 ">
  
   
   <div className="p-8 sm:p-1  ">
     <p className="text-[16px] text-yellow-500 font-geological sm:p-1 sm:text-[13px]">Choose Stake Tier:</p>
     <div className="my-5 flex gap-1 sm:gap-10 sm:ml-1">
       <div className="flex items-center flex-col  ">
       <button className="text-[16px] text-white font-night rounded-2xl px-8 border-orange-600 border  hover:bg-orange-600 active:bg-orange-700 active:border-8 focus:border-8 focus:outline-none focus:ring focus:ring-orange-700 sm:text-[10px] sm:px-[1px] sm:pb-[2px] sm:m-[0px] sm:h-[1.6rem] sm:w-[5rem]"  onClick={() => handleTierChange("2")} style={selectedTier === 'Gold' ? selectedButtonStyle : unselectedButtonStyle}>Bronze</button>
       <p className="text-yellow-500 text-[10px] font-geological sm:text-[9px] ">3days minimum</p>
       </div>
       <div className="flex flex-col items-center">
         <button className="text-[16px] text-white font-night rounded-2xl px-8 border-gray-500 border  hover:bg-gray-600 active:bg-gray-700 active:border-8 focus:border-8 focus:outline-none focus:ring focus:ring-gray-700 sm:text-[10px] sm:px-[1px] sm:py-[0px] sm:m-[1px] sm:h-[1.6rem] sm:w-[5rem]"  onClick={() => handleTierChange("1")} style={selectedTier === 'Silver' ? selectedButtonStyle : unselectedButtonStyle}>Silver</button>
         <p className="text-yellow-500 text-[10px] font-geological sm:text-[9px] ">5days minimum</p>
         </div>
       <div className="flex flex-col items-center">
         <button className="text-[16px] text-white font-night rounded-2xl px-10 border-yellow-700 border  hover:bg-yellow-700 active:bg-yellow-700 active:border-8 focus:outline-none focus:ring focus:border-8 focus:ring-yellow-700 sm:text-[10px] sm:px-[1px] sm:py-[0px] sm:h-[1.6rem] sm:m-[1px] sm:w-[5rem]" onClick={() => handleTierChange("0")}style={selectedTier === 'Bronze' ? selectedButtonStyle : unselectedButtonStyle}>Gold</button>
       <p className="text-yellow-500 text-[10px] font-geological sm:text-[9px] ">8days minimum</p>
       </div>
     </div>
   </div>

   <div className="px-3 flex gap-3 sm:flex-col sm:items-center sm:gap-1">
     <div>
       <input className="w-[28rem] pl-16 bg-[#242323] focus:outline-none text-white p-5 h-[4rem] sm:w-[20rem] sm:p-1 sm:h-[3rem] "  type="number" value={stakeAmount}
       onChange={handleStakeAmountChange} />
       <p className="ml-[19rem] text-yellow-500 text-sm font-bold sm:ml-[0rem] sm:text-[10px] ">$MET Tokens stake</p>
     </div>
     <button className="text-lg text-white font-night rounded-2xl px-[5rem] h-14 border-gray-500 border sm:px-[1rem] sm:h-10 sm:text-[17px] sm:w-[12rem] " onClick={stakeTokens}>STAKE</button>
   </div>
   <div className="px-3 mt-8 flex gap-3 sm:flex-col sm:items-center">
     <div>
       <div className=" flex text-right text-xl  gap-[1rem] w-[28rem] bg-[#242323] focus:outline-none text-white p-5 h-[4rem] sm:w-[20rem] sm:p-1 sm:gap-[10px] sm:text-left sm:h-[3rem] "><img className="sm:w-[1.2rem] text-left sm:pt-[3px]" src={icon}></img><p className=" text-center sm:text-sm sm:pt-3">{expectedReward  / 10**18}</p></div>
       <p className="ml-[18rem] text-yellow-500 text-sm font-bold sm:ml-[0rem] sm:text-[10px] ">$MET Tokens earned</p>
     </div>
     <button className="text-lg text-white font-night rounded-2xl px-[4rem] h-14 border-gray-500 border sm:px-[1rem] sm:h-10 sm:text-[17px] sm:w-[12rem]" onClick={Harvest}>HARVEST</button>
   </div>
 </div>
 
</div>
<div className="mt-12 flex gap-12 px-[11rem]  sm:mt-8 sm:gap-12 sm:px-0 sm:w-[100px]">
 <div className="flex flex-col items-center  sm:ml-[-10px] ">
   <div className="flex flex-col items-center py-6 border border-gray-600 w-[25rem] px-[2rem] sm:py-1 sm:px-0 sm:w-[9rem] ">
     <p className="text-white sm:text-[14px]">{stakedAmount / 10**18}</p>
     <p className="text-yellow-500 text-xs sm:ml-[0rem] sm:text-[10px]">$MET Token Staked</p>
   </div>
   <p className="text-gray-500 text-center sm:text-[16px]">Token Staked</p>
   </div>
   <div>
   <div className="flex flex-col items-center py-8 border border-gray-600 w-[23rem] px-[2rem] sm:py-2 sm:ml=[-10px] sm:px-0 sm:w-[9rem] ">
     <p className="text-white ">3%</p>
     
   </div>
   <p className="text-gray-500 text-center sm:text-[14px]">APR</p>
   </div>

 </div>
                </div>
                );
              }

              if (chain.unsupported) {
                return (
                  <div className="p-12 sm:w-[80px]">
  <div>
     
      <button onClick={openConnectModal} className="bg-gray-600 border rounded-2xl text-white px-5 py-3 sm:text-[5px] sm:px-1 sm:w-10 sm:py-1">Connect</button>
  </div>
  <div className="flex items-center justify-center flex-col sm:w-[310px]  ">
 
    <p className="text-white text-[13px] text-yellow-600 font-night ">METAHUMAN</p>
    <p className="text-[32px] text-white font-geological">STAKE</p>
  </div>
  <div className="flex items-center justify-center flex-col sm:w-[280px]  " >
    <div className="border border-gray-600 w-[800px] h-[450px] px-[2rem] mx-[5rem] sm:w-[360px] sm:h-[400px] sm:px-[0rem] sm:mr-0 sm:ml-8 ">
     
      
      <div className="p-8 sm:p-1  ">
        <p className="text-[16px] text-yellow-500 font-geological sm:p-1 sm:text-[13px]">Choose Stake Tier:</p>
        <div className="my-5 flex gap-1 sm:gap-10 sm:ml-1">
          <div className="flex items-center flex-col  ">
          <button className="text-[16px] text-white font-night rounded-2xl px-8 border-orange-600 border  hover:bg-orange-600 active:bg-orange-700 active:border-8 focus:border-8 focus:outline-none focus:ring focus:ring-orange-700 sm:text-[10px] sm:px-[1px] sm:pb-[2px] sm:m-[0px] sm:h-[1.6rem] sm:w-[5rem]"  onClick={() => handleTierChange("2")} style={selectedTier === 'Gold' ? selectedButtonStyle : unselectedButtonStyle}>Bronze</button>
          <p className="text-yellow-500 text-[10px] font-geological sm:text-[9px] ">3days minimum</p>
          </div>
          <div className="flex flex-col items-center">
            <button className="text-[16px] text-white font-night rounded-2xl px-8 border-gray-500 border  hover:bg-gray-600 active:bg-gray-700 active:border-8 focus:border-8 focus:outline-none focus:ring focus:ring-gray-700 sm:text-[10px] sm:px-[1px] sm:py-[0px] sm:m-[1px] sm:h-[1.6rem] sm:w-[5rem]"  onClick={() => handleTierChange("1")} style={selectedTier === 'Silver' ? selectedButtonStyle : unselectedButtonStyle}>Silver</button>
            <p className="text-yellow-500 text-[10px] font-geological sm:text-[9px] ">5days minimum</p>
            </div>
          <div className="flex flex-col items-center">
            <button className="text-[16px] text-white font-night rounded-2xl px-10 border-yellow-700 border  hover:bg-yellow-700 active:bg-yellow-700 active:border-8 focus:outline-none focus:ring focus:border-8 focus:ring-yellow-700 sm:text-[10px] sm:px-[1px] sm:py-[0px] sm:h-[1.6rem] sm:m-[1px] sm:w-[5rem]" onClick={() => handleTierChange("0")}style={selectedTier === 'Bronze' ? selectedButtonStyle : unselectedButtonStyle}>Gold</button>
          <p className="text-yellow-500 text-[10px] font-geological sm:text-[9px] ">8days minimum</p>
          </div>
        </div>
      </div>

      <div className="px-3 flex gap-3 sm:flex-col sm:items-center sm:gap-1">
        <div>
          <input className="w-[28rem] pl-16 bg-[#242323] focus:outline-none text-white p-5 h-[4rem] sm:w-[20rem] sm:p-1 sm:h-[3rem] "  type="number" value={stakeAmount}
          onChange={handleStakeAmountChange} />
          <p className="ml-[19rem] text-yellow-500 text-sm font-bold sm:ml-[0rem] sm:text-[10px] ">$MET Tokens stake</p>
        </div>
        <button className="text-lg text-white font-night rounded-2xl px-[5rem] h-14 border-gray-500 border sm:px-[1rem] sm:h-10 sm:text-[17px] sm:w-[12rem] " onClick={stakeTokens}>STAKE</button>
      </div>
      <div className="px-3 mt-8 flex gap-3 sm:flex-col sm:items-center">
        <div>
          <div className=" flex text-right text-xl  gap-[1rem] w-[28rem] bg-[#242323] focus:outline-none text-white p-5 h-[4rem] sm:w-[20rem] sm:p-1 sm:gap-[10px] sm:text-left sm:h-[3rem] "><img className="sm:w-[1.2rem] text-left sm:pt-[3px]" src={icon}></img><p className=" text-center sm:text-sm sm:pt-3">{expectedReward  / 10**18}</p></div>
          <p className="ml-[18rem] text-yellow-500 text-sm font-bold sm:ml-[0rem] sm:text-[10px] ">$MET Tokens earned</p>
        </div>
        <button className="text-lg text-white font-night rounded-2xl px-[4rem] h-14 border-gray-500 border sm:px-[1rem] sm:h-10 sm:text-[17px] sm:w-[12rem]" onClick={Harvest}>HARVEST</button>
      </div>
    </div>
    
  </div>
  <div className="mt-12 flex gap-12 px-[11rem]  sm:mt-8 sm:gap-12 sm:px-0 sm:w-[100px]">
    <div className="flex flex-col items-center  sm:ml-[-10px] ">
      <div className="flex flex-col items-center py-6 border border-gray-600 w-[25rem] px-[2rem] sm:py-1 sm:px-0 sm:w-[9rem] ">
        <p className="text-white sm:text-[14px]">{stakedAmount / 10**18}</p>
        <p className="text-yellow-500 text-xs sm:ml-[0rem] sm:text-[10px]">$MET Token Staked</p>
      </div>
      <p className="text-gray-500 text-center sm:text-[16px]">Token Staked</p>
      </div>
      <div>
      <div className="flex flex-col items-center py-8 border border-gray-600 w-[23rem] px-[2rem] sm:py-2 sm:ml=[-10px] sm:px-0 sm:w-[9rem] ">
        <p className="text-white ">3%</p>
        
      </div>
      <p className="text-gray-500 text-center sm:text-[14px]">APR</p>
      </div>

    </div>
</div>
                  
                );
              }
              if (connected) {

              return (
                <>
                <div style={{ display: 'flex', gap: 12 }}>
                 

                  
                </div>


<div className="w-[100%] h-[100%] ">
    
    
    <button className="mt-1 ml-12 text-[14px] md:text-lg text-yellow-600 font-akkuratPro"
                    onClick={openChainModal}
                    style={{ display: 'flex', alignItems: 'center' }}
                    type="button"
                  >
                    {chain.hasIcon && (
                      <div
                        style={{
                          background: chain.iconBackground,
                          accentColor: '#b56702',
                          width: 12,
                          height: 12,
                          borderRadius: 999,
                          overflow: 'hidden',
                          marginRight: 4,
                        }}
                      >
                        {chain.iconUrl && (
                          <img
                            alt={chain.name ?? 'Chain icon'}
                            src={chain.iconUrl}
                            style={{ width: 10, height: 10, accentColor: '#b56702', }}
                          />
                        )}
                      </div>
                    )}
                    {/* {chain.name} */}
                  </button>
                  {/* <button className="mt-1 ml-10 text-[14px] md:text-lg text-yellow-600 font-akkuratPro"  type="button">
                    {account.displayName} 
                    <br></br>
                    {account.displayBalance
                      ? ` (${account.displayBalance})`
                      : ''}
                      <br></br>
                      
                  </button> */}

  


<div className="p-12 w-full h-full sm:w-full sm:h-full">
<div>
   
                  </div>
  <div className="flex items-center justify-center flex-col sm:w-[310px]  ">
 
    <p className="text-white text-[13px] text-yellow-600 font-night ">METAHUMAN</p>
    <p className="text-[32px] text-white font-geological">STAKE</p>
  </div>
  <div className="flex items-center justify-center flex-col sm:w-[280px]  " >
    <div className="border border-gray-600 w-[800px] h-[450px] px-[2rem] mx-[5rem] sm:w-[360px] sm:h-[400px] sm:px-[0rem] sm:mr-0 sm:ml-8 ">
     
      
      <div className="p-8 sm:p-1  ">
        <p className="text-[16px] text-yellow-500 font-geological sm:p-1 sm:text-[13px]">Choose Stake Tier:</p>
        <div className="my-5 flex gap-1 sm:gap-10 sm:ml-1">
          <div className="flex items-center flex-col  ">
          <button className="text-[16px] text-white font-night rounded-2xl px-8 border-orange-600 border  hover:bg-orange-600 active:bg-orange-700 active:border-8 focus:border-8 focus:outline-none focus:ring focus:ring-orange-700 sm:text-[10px] sm:px-[1px] sm:pb-[2px] sm:m-[0px] sm:h-[1.6rem] sm:w-[5rem]"  onClick={() => handleTierChange("2")} style={selectedTier === 'Gold' ? selectedButtonStyle : unselectedButtonStyle}>Bronze</button>
          <p className="text-yellow-500 text-[10px] font-geological sm:text-[9px] ">3days minimum</p>
          <p className="text-yellow-500 text-[10px] font-geological sm:text-[9px] ">3% APR</p>
          </div>
          <div className="flex flex-col items-center">
            <button className="text-[16px] text-white font-night rounded-2xl px-8 border-gray-500 border  hover:bg-gray-600 active:bg-gray-700 active:border-8 focus:border-8 focus:outline-none focus:ring focus:ring-gray-700 sm:text-[10px] sm:px-[1px] sm:py-[0px] sm:m-[1px] sm:h-[1.6rem] sm:w-[5rem]"  onClick={() => handleTierChange("1")} style={selectedTier === 'Silver' ? selectedButtonStyle : unselectedButtonStyle}>Silver</button>
            <p className="text-yellow-500 text-[10px] font-geological sm:text-[9px] ">5days minimum</p>
            <p className="text-yellow-500 text-[10px] font-geological sm:text-[9px] ">5% APR</p>
            </div>
          <div className="flex flex-col items-center">
            <button className="text-[16px] text-white font-night rounded-2xl px-10 border-yellow-700 border  hover:bg-yellow-700 active:bg-yellow-700 active:border-8 focus:outline-none focus:ring focus:border-8 focus:ring-yellow-700 sm:text-[10px] sm:px-[1px] sm:py-[0px] sm:h-[1.6rem] sm:m-[1px] sm:w-[5rem]" onClick={() => handleTierChange("0")}style={selectedTier === 'Bronze' ? selectedButtonStyle : unselectedButtonStyle}>Gold</button>
          <p className="text-yellow-500 text-[10px] font-geological sm:text-[9px] ">8days minimum</p>
          <p className="text-yellow-500 text-[10px] font-geological sm:text-[9px] ">8% APR</p>
          </div>
        </div>
      </div>

      <div className="px-3 flex gap-3 sm:flex-col sm:items-center sm:gap-1">
        <div>
          <input className="w-[28rem] pl-16 bg-[#242323] focus:outline-none text-white p-5 h-[4rem] sm:w-[20rem] sm:p-1 sm:h-[3rem] "  type="number" value={stakeAmount}
          onChange={handleStakeAmountChange} />
          <p className="ml-[19rem] text-yellow-500 text-sm font-bold sm:ml-[0rem] sm:text-[10px] ">$MET Tokens stake</p>
        </div>
        <button className="text-lg text-white font-night rounded-2xl px-[5rem] h-14 border-gray-500 border sm:px-[1rem] sm:h-10 sm:text-[17px] sm:w-[12rem] " onClick={stakeTokens}>STAKE</button>
      </div>
      <div className="px-3 mt-8 flex gap-3 sm:flex-col sm:items-center">
        <div>
          <div className=" flex text-right text-xl  gap-[1rem] w-[28rem] bg-[#242323] focus:outline-none text-white p-5 h-[4rem] sm:w-[20rem] sm:p-1 sm:gap-[10px] sm:text-left sm:h-[3rem] "><img className="sm:w-[1.2rem] text-left sm:pt-[3px]" src={icon}></img><p className=" text-center sm:text-sm sm:pt-3">{expectedReward }</p></div>
          <p className="ml-[18rem] text-yellow-500 text-sm font-bold sm:ml-[0rem] sm:text-[10px] ">$MET Tokens earned</p>
        </div>
        <button className="text-lg text-white font-night rounded-2xl px-[4rem] h-14 border-gray-500 border sm:px-[1rem] sm:h-10 sm:text-[17px] sm:w-[12rem]" onClick={Harvest}>HARVEST</button>
      </div>
    </div>
    
  </div>
  <div className="mt-12 flex gap-12 px-[11rem]  sm:mt-8 sm:gap-12 sm:px-0 sm:w-[100px]">
    <div className="flex flex-col items-center  sm:ml-[-10px] ">
      <div className="flex flex-col items-center py-6 border border-gray-600 w-[25rem] px-[2rem] sm:py-1 sm:px-0 sm:w-[9rem] ">
        <p className="text-white sm:text-[14px]">{stakedAmount}</p>
        <p className="text-yellow-500 text-xs sm:ml-[0rem] sm:text-[10px]">$MET Token Staked</p>
      </div>
      <p className="text-gray-500 text-center sm:text-[16px]">Token Staked</p>
      </div>
      <div>
      <div className="flex flex-col items-center py-8 border border-gray-600 w-[23rem] px-[2rem] sm:py-2 sm:ml=[-10px] sm:px-0 sm:w-[9rem] ">
        <p className="text-white ">{rewardPercent}%</p>
        
      </div>
      <p className="text-gray-500 text-center sm:text-[14px]">APR</p>
      </div>

    </div>
</div>



</div>

</>

              );
            }
            })()}
          </div>
        );
      }}
    </ConnectButton.Custom>
    
                
    </>);
};

export default Home;